import { ColorGradient } from './ItemColor.model';
import { StyledContainer } from './ItemColor.styled';

const ItemColor = ({
	image,
	size,
	imageSize,
	color,
	style,
	...props
}: {
	image: string;
	size: number;
	imageSize: number;
	color: ColorGradient;
	style?: React.CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledContainer
			style={{ width: size, height: size, background: color, ...style }}
			{...props}
		>
			<img
				src={image}
				style={{ position: 'relative' }}
				width={imageSize}
				height={imageSize}
			/>
		</StyledContainer>
	);
};

export { ItemColor };
